import { Logger } from 'aws-amplify';
import React, { useEffect, useState } from 'react';

import Language from '../constants/localization';
import { Locale, setting } from '../constants/translation';
import { query, Setting, subscribe, Value } from '../models/settings';
import { translationBook, updateTranslations } from './book';

const logger = new Logger('translation-provider');

export const TranslationContext = React.createContext<Value | null>(null);

export const getValue = async (): Promise<Value> => {
  let current: Value | undefined;
  const stored: Setting[] = await query(setting);
  // eslint-disable-next-line array-callback-return
  stored.map((s) => {
    current = s.value as Value;
  });

  return Promise.resolve(
    translationBook(current || null, Language.locale() as Locale).name
  );
};

type Props = {
  children:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
};

const TranslationProvider = (props: Props) => {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);
  const [translation, setTranslation] = useState<Value | null>(null);
  const { children } = props;

  const updateTranslation = (t: string | null) => {
    if (t !== translation) {
      updateTranslations(t);
      setTranslation(t);
    }
  };

  useEffect(() => {
    getValue()
      .then((t) => updateTranslation(t))
      .catch(() => updateTranslation(null));

    let subscription: any;

    subscribe('UPDATE', (updated) => {
      if (
        updated.key &&
        updated.key === setting &&
        updated.value !== translation
      ) {
        updateTranslation(updated.value);
        logger.info(
          `To update ${setting} to ${updated.value} from ${translation} on subscription`
        );
      }
    }).then((v) => {
      subscription = v;
    });

    updateTranslations(translation);
    setLoadingComplete(true);

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  if (!isLoadingComplete) return null;

  return (
    <TranslationContext.Provider value={translation}>
      {children}
    </TranslationContext.Provider>
  );
};

export default TranslationProvider;
